// Special warranty agreements with specific organisations.
// Add a new entry here when a deal is established.
// orgName is matched case-insensitively against the org's name.
const SPECIAL_WARRANTY_AGREEMENTS = [
  { orgName: 'NORTHINVENTTESTUSER', extraMonths: 12 }
];

export function getOrgWarrantyExtra(orgName) {
  if (!orgName || typeof orgName !== 'string') return 0;
  const norm = orgName.trim().toLowerCase();
  const match = SPECIAL_WARRANTY_AGREEMENTS.find(a => a.orgName.toLowerCase() === norm);
  return match ? match.extraMonths : 0;
}
